import { render, staticRenderFns } from "./BooksDetails.vue?vue&type=template&id=639f7658&scoped=true&"
import script from "./BooksDetails.vue?vue&type=script&lang=js&"
export * from "./BooksDetails.vue?vue&type=script&lang=js&"
import style0 from "./BooksDetails.vue?vue&type=style&index=0&id=639f7658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f7658",
  null
  
)

export default component.exports